export default __webpack_public_path__ + "static/media/mot_3.07ab6834.svg";